import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Home, ConsultarTramite, RealizarTramite } from "@Pages";
import { useChangeTitle } from "@Hooks";

const PublicRoute = () => {
  const location = useLocation();
  const { changeTitle } = useChangeTitle();
  useEffect(() => {
    changeTitle(location);
  }, [location]);
  return (
    <Routes>
      <Route index path="/" element={<Home />} />
      <Route path="/consultar-tramite" element={<ConsultarTramite />} />
      <Route path="/realizar-tramite" element={<RealizarTramite />} />
    </Routes>
  );
};

export default PublicRoute;